import { AdminRoute } from "../components/ProtectedRoute";
import { DashboardLayout } from "../components/DashboardLayout";

export default [AdminRoute, DashboardLayout];